module.exports = "<!-- eventMangerAddonsCtrl -->\n<div id=\"admin-events-event-eventinfo\">\n  <div class=\"row\" ng-if=\"eventMangerAddonsCtrl.loaded\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 p-b-xl\">\n      <external-editor event=\"eventMangerAddonsCtrl.event\"></external-editor>\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/eventManager/event/addons/template.html
// module id = 1790
// module chunks = 0